import React from "react";
import { Spinner } from "react-bootstrap";

const Loader = () => {
  return (
    <div className="d-flex justify-content-center border align-items-center" style={{height:"60px"}}>
      <Spinner/>
    </div>
  );
};

export default Loader;
